import apiService from './api.service';

/**
 * Сервис для работы с продуктами
 * Конвертировано из Angular ProductService
 */
class ProductService {
    /**
     * Получить список продуктов по фильтрам
     */
    async getProducts(filters: any, limit: number = 12, offset: number = 0): Promise<any> {
        return apiService.post(`/api/core/products/search/?limit=${limit}&offset=${offset}`, filters);
    }

    /**
     * Поиск продуктов
     */
    async searchProductions(q: string): Promise<any[]> {
        return apiService.get('/api/core/productions/search_suggest//', { q });
    }


    /**
     * Получить следующую страницу продуктов
     */
    async getNextProducts(nextUrl: string, filters: any): Promise<any> {
        // Извлекаем путь из полного URL
        const url = new URL(nextUrl);
        const path = url.pathname + url.search;
        return apiService.post(path, filters);
    }

    /**
     * Получить продукты по кастомному URL
     */
    async getProductsByUrl(filters: any, url: string): Promise<any> {
        return apiService.post(url, filters);
    }

    /**
     * Получить продукт по ID
     */
    async getProduct(id: number): Promise<any> {
        return apiService.get(`/api/core/products/${id}/`, {});
    }

    /**
     * Получить медианную цену
     */
    async getMedianPrice(data: any): Promise<any> {
        return apiService.post('https://bdc.goszakup.gov.kz/bdc-api/v1/analysis', data);
    }
}

export default new ProductService();
